/**
 * Context shared by the InspectionsListing component and its cell renderers.
 *
 * Purpose:
 *   - Provides `statusesForSelect` to the inline-edit StatusRenderer without
 *     prop-drilling through column definitions.
 *   - Provides `onRowUpdate` so a single-row update (inline status edit) can
 *     patch the React Query cache without a full re-fetch.
 *
 * This replaces the legacy `ColumnMenuContext` + reducer dispatch pattern.
 */
import { createContext, useContext } from 'react';
const InspectionsListingContext = createContext(null);
export function useInspectionsListingContext() {
    const value = useContext(InspectionsListingContext);
    if (value === null) {
        throw new Error('useInspectionsListingContext must be used within an InspectionsListingProvider');
    }
    return value;
}
export const InspectionsListingProvider = InspectionsListingContext.Provider;
